



































import FullCalendar from '@fullcalendar/vue';
import { CalendarApi, CalendarOptions, EventClickArg } from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { planningAssitantCategory } from '../../../shared/enums/planningAssitantCategory.js';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';

export default {
  components: {
    Icon,
    FullCalendar,
  },
  props: {
    startDate: { type: String, required: true },
    endDate: { type: String, required: true },
    eventSources: { type: Array, required: true },
    resources: { type: Array, default: null },
  },
  emits: ['addResource', 'removeResource', 'removeInvitee', 'openDatePicker', 'eventClick'],
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    options(): CalendarOptions {
      return {
        schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENSE_KEY,
        locale: 'da',
        plugins: [resourceTimelinePlugin],
        initialView: 'resourceTimeline',
        initialDate: this.startDate,
        headerToolbar: {
          left: 'title openCalendar prev,next',
          right: 'today',
        },
        customButtons: {
          openCalendar: {
            icon: ' icon-Aula_down-arrow',
            click: this.emitOpenDatePicker,
          },
        },
        buttonText: {
          today: this.$t('calendar.today'),
        },
        weekends: true,
        weekNumbers: false,
        weekNumberFormat: { week: 'long' },
        titleFormat: { month: 'long', day: '2-digit', year: 'numeric' },
        slotLabelFormat: { hour: '2-digit', minute: '2-digit' },
        dayHeaderFormat: { month: 'long', day: '2-digit', year: 'numeric' },
        contentHeight: 500,
        scrollTime: '08:00',
        slotEventOverlap: false,
        slotMinWidth: 100,
        eventSources: this.eventSources,
        resources: this.resources,
        resourceGroupField: 'category',
        resourcesInitiallyExpanded: true,
        resourceAreaWidth: 300,
        resourceAreaHeaderContent: this.$t('calendar.resources'),
        resourceGroupLabelContent: this.getResourceLabelContent,
        eventClick: this.emitEventClick,
      };
    },
  },
  methods: {
    getApi(): CalendarApi {
      return this.$refs.calendar.getApi();
    },
    getResourceLabelContent(arg) {
      switch (arg.groupValue) {
        case planningAssitantCategory.INVITEES:
          return this.$t('user.participants');
        case planningAssitantCategory.LOCATION:
          return this.$t('calendar.selected_locations');
        case planningAssitantCategory.RESOURCES:
          return this.$t('calendar.selected_resources');
        default:
          return arg.groupValue;
      }
    },
    getCanAddResource(resource) {
      const category = resource.extendedProps.category;
      const events = resource.getEvents();
      const hasOverlap = events.some(
        resourceEvent =>
          DateTimeUtil.isBetween(resourceEvent.start, this.startDate, this.endDate, '[]') ||
          DateTimeUtil.isBetween(resourceEvent.end, this.startDate, this.endDate, '[]')
      );
      if (hasOverlap) {
        return false;
      }
      switch (category) {
        case planningAssitantCategory.RESOURCES:
        case planningAssitantCategory.LOCATION:
        case planningAssitantCategory.INVITEES:
          return false;
        default:
          return true;
      }
    },
    getCanRemoveResource(resource) {
      const category = resource.extendedProps.category;

      switch (category) {
        case planningAssitantCategory.RESOURCES:
        case planningAssitantCategory.LOCATION:
          return true;
        default:
          return false;
      }
    },
    getCanRemoveInvitee(resource) {
      return resource.extendedProps.inviteeType === 'invitee';
    },
    emitOpenDatePicker() {
      this.$emit('openDatePicker');
    },
    emitAddResource(resource) {
      this.$emit('addResource', { ...resource.extendedProps, title: resource.title });
    },
    emitRemoveResource(resource) {
      this.$emit('removeResource', { ...resource.extendedProps, title: resource.title });
    },
    emitRemoveInvitee(resource) {
      this.$emit('removeInvitee', { ...resource.extendedProps, title: resource.title });
    },
    emitEventClick(eventInfo: EventClickArg) {
      this.$emit('eventClick', eventInfo);
    },
  },
};
